// eslint-disable-next-line unused-imports/no-unused-imports, @typescript-eslint/no-unused-vars
import React, { useState } from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { htmlT } from 'utils/generic';

import {
  ActionButton,
  ActionContainer,
  Container,
  Content,
  ImgCheck,
  ImgCollumn,
  Name,
  TextCollumn,
  TextDescription,
  Wrapper,
} from './styles';

interface Props {
  refundableType: string | undefined;
  onChange: () => void;
}

const FilterHotelRefundable = ({ refundableType, onChange }: Props) => {
  const { t } = useStoreTranslation();

  const text = () => {
    if (refundableType === undefined) {
      return t('hotelsFilters.cancelPolicyImage.apply');
    }

    if (refundableType.toLowerCase() === 'refundable') {
      return t('hotelsFilters.cancelPolicyImage.remove');
    } else {
      return t('hotelsFilters.cancelPolicyImage.apply');
    }
  };

  return (
    <>
      <Container>
        <Wrapper>
          <Content>
            <TextCollumn>
              <Name $active>{htmlT(t, 'hotelsFilters.cancelPolicyImage.title')}</Name>
              <br />
              <TextDescription>{htmlT(t, 'hotelsFilters.cancelPolicyImage.text')}</TextDescription>
            </TextCollumn>
            <ImgCollumn>
              <ImgCheck src="/images/ilustra-check.png" />
            </ImgCollumn>
          </Content>
          <ActionContainer>
            <ActionButton onClick={onChange}>{text()}</ActionButton>
          </ActionContainer>
        </Wrapper>
      </Container>
    </>
  );
};
export default FilterHotelRefundable;
